import type { BusinessProfile, PaymentRequest } from "./types";

export const categories = [
  "Tutor",
  "Beauty Salon",
  "Restaurant / Cafe",
  "Online Shop",
  "Freelancer",
  "Repair Service",
  "Pet Service",
  "Charity / NGO",
  "Club / Association",
  "Event Organizer",
  "Healthcare / Clinic",
  "Professional Service",
  "Home Service",
  "Market Stall",
  "Other"
];

export const districts = [
  "Central and Western",
  "Wan Chai",
  "Eastern",
  "Southern",
  "Yau Tsim Mong",
  "Sham Shui Po",
  "Kowloon City",
  "Wong Tai Sin",
  "Kwun Tong",
  "Tsuen Wan",
  "Tuen Mun",
  "Yuen Long",
  "North",
  "Tai Po",
  "Sha Tin",
  "Sai Kung",
  "Islands",
  "Kwai Tsing"
];

export const seedBusinesses: BusinessProfile[] = [
  {
    id: "biz_abc_florist",
    ownerEmail: "owner@abcflorist.example",
    businessName: "ABC Florist",
    slug: "abc-florist",
    category: "Online Shop",
    district: "Central and Western",
    shortDescription: "Fresh bouquet orders, pop-up arrangements, and event flowers.",
    longDescription:
      "ABC Florist takes FPS payments for deposits, delivery orders, and invoice balances. Customers pay directly through their own bank or wallet app.",
    contactPerson: "Ada Chan",
    whatsapp: "85261234567",
    phone: "28681234",
    email: "hello@abcflorist.example",
    website: "https://example.com",
    instagram: "abcflorist.hk",
    address: "Central Market, Hong Kong",
    languagePreference: "Both",
    directoryVisible: true,
    status: "published",
    verificationLevel: 3,
    fpsProxyType: "FPS ID",
    fpsProxyValue: "1234567",
    currency: "HKD",
    expectedRecipientName: "ABC Florist Limited",
    bankName: "FPS receiving bank / SVF shown in payer app",
    paymentRemarksInstruction: "Use your invoice or order number in the FPS remarks field.",
    defaultPaymentNote: "Flower order deposit",
    hideRawProxy: false,
    showCopyButton: true,
    updatedAt: new Date().toISOString()
  },
  {
    id: "biz_happy_tutor",
    ownerEmail: "hello@happytutor.example",
    businessName: "Happy Tutor Studio",
    slug: "happy-tutor-studio",
    category: "Tutor",
    district: "Sha Tin",
    shortDescription: "Primary and junior secondary English lessons.",
    longDescription:
      "Parents can use this page to pay tuition balances by FPS and copy the student name into the reference field.",
    contactPerson: "Miss Lee",
    whatsapp: "85261239876",
    phone: "26001234",
    email: "hello@happytutor.example",
    website: "",
    instagram: "happytutor.hk",
    address: "Sha Tin, New Territories",
    languagePreference: "Both",
    directoryVisible: true,
    status: "published",
    verificationLevel: 2,
    fpsProxyType: "Mobile",
    fpsProxyValue: "+852 6123 9876",
    currency: "HKD",
    expectedRecipientName: "LEE WAI MAN",
    bankName: "",
    paymentRemarksInstruction: "Enter the student name and month, for example CHRIS JUN.",
    defaultPaymentNote: "Tuition fee",
    hideRawProxy: false,
    showCopyButton: true,
    updatedAt: new Date().toISOString()
  },
  {
    id: "biz_mk_repair",
    ownerEmail: "repair@example.com",
    businessName: "Mong Kok Phone Repair",
    slug: "mong-kok-phone-repair",
    category: "Repair Service",
    district: "Yau Tsim Mong",
    shortDescription: "Walk-in phone repair deposits and parts payments.",
    longDescription:
      "Customers may pay diagnostics, parts deposits, and repair balances through FPS after verifying the recipient details.",
    contactPerson: "Ken",
    whatsapp: "85265554433",
    phone: "23990000",
    email: "repair@example.com",
    website: "",
    instagram: "",
    address: "Mong Kok, Kowloon",
    languagePreference: "Both",
    directoryVisible: true,
    status: "published",
    verificationLevel: 1,
    fpsProxyType: "FPS ID",
    fpsProxyValue: "7654321",
    currency: "HKD",
    expectedRecipientName: "MK PHONE REPAIR",
    bankName: "",
    paymentRemarksInstruction: "Use your repair ticket number.",
    defaultPaymentNote: "Repair payment",
    hideRawProxy: false,
    showCopyButton: true,
    updatedAt: new Date().toISOString()
  },
  {
    id: "biz_green_paw",
    ownerEmail: "bookings@greenpaw.example",
    businessName: "Green Paw Pet Grooming",
    slug: "green-paw-pet-grooming",
    category: "Pet Service",
    district: "Tsuen Wan",
    shortDescription: "Pet grooming bookings and package balances.",
    longDescription:
      "Pay booking deposits and grooming package balances by FPS. Please include the pet name in payment remarks.",
    contactPerson: "Carmen",
    whatsapp: "85268880011",
    phone: "24110000",
    email: "bookings@greenpaw.example",
    website: "",
    instagram: "greenpaw.hk",
    address: "Tsuen Wan, Hong Kong",
    languagePreference: "Both",
    directoryVisible: true,
    status: "published",
    verificationLevel: 4,
    fpsProxyType: "Email",
    fpsProxyValue: "payments@greenpaw.example",
    currency: "HKD",
    expectedRecipientName: "Green Paw Pet Grooming",
    bankName: "",
    paymentRemarksInstruction: "Enter pet name and booking date.",
    defaultPaymentNote: "Pet grooming",
    hideRawProxy: true,
    showCopyButton: false,
    updatedAt: new Date().toISOString()
  },
  {
    id: "biz_charity_run",
    ownerEmail: "donate@charityrun.example",
    businessName: "Charity Run HK",
    slug: "charity-run-hk",
    category: "Charity / NGO",
    district: "Wan Chai",
    shortDescription: "Donation collection and community run registration.",
    longDescription:
      "Supporters can use FPS to donate or pay registration fees. Donation receipts are issued manually after confirmation.",
    contactPerson: "Volunteer Team",
    whatsapp: "85269991234",
    phone: "25000000",
    email: "donate@charityrun.example",
    website: "https://example.org",
    instagram: "charityrunhk",
    address: "Wan Chai, Hong Kong",
    languagePreference: "Both",
    directoryVisible: true,
    status: "published",
    verificationLevel: 5,
    fpsProxyType: "FPS ID",
    fpsProxyValue: "9988776",
    currency: "HKD",
    expectedRecipientName: "Charity Run HK",
    bankName: "",
    paymentRemarksInstruction: "Use DONATION or your registration code.",
    defaultPaymentNote: "Donation",
    hideRawProxy: false,
    showCopyButton: true,
    updatedAt: new Date().toISOString()
  },
  {
    id: "biz_candle_shop",
    ownerEmail: "shop@candles.example",
    businessName: "Handmade Candle IG Shop",
    slug: "handmade-candle-ig-shop",
    category: "Online Shop",
    district: "Kwai Tsing",
    shortDescription: "Small batch candles sold through Instagram and WhatsApp.",
    longDescription:
      "Share FPS payment links for product reservations, shipping fees, and order balances.",
    contactPerson: "Nora",
    whatsapp: "85261112222",
    phone: "",
    email: "shop@candles.example",
    website: "",
    instagram: "hk.candle.studio",
    address: "Kwai Tsing, Hong Kong",
    languagePreference: "Both",
    directoryVisible: true,
    status: "published",
    verificationLevel: 0,
    fpsProxyType: "Mobile",
    fpsProxyValue: "+852 6111 2222",
    currency: "HKD",
    expectedRecipientName: "NORA WONG",
    bankName: "",
    paymentRemarksInstruction: "Use your order number from Instagram DM.",
    defaultPaymentNote: "Candle order",
    hideRawProxy: false,
    showCopyButton: true,
    updatedAt: new Date().toISOString()
  }
];

export const seedRequests: PaymentRequest[] = [
  {
    id: "req_abc_deposit",
    businessId: "biz_abc_florist",
    requestCode: "INV-1001",
    amount: "500",
    currency: "HKD",
    title: "Wedding bouquet deposit",
    reference: "INV1001",
    customerName: "Demo Customer",
    customerContact: "",
    expiresAt: "",
    internalNote: "Demo request",
    status: "Sent",
    createdAt: new Date().toISOString()
  },
  {
    id: "req_tutor_june",
    businessId: "biz_happy_tutor",
    requestCode: "JUN-TUITION",
    amount: "1200",
    currency: "HKD",
    title: "June tuition fee",
    reference: "CHRIS-JUN",
    customerName: "Chris",
    customerContact: "",
    expiresAt: "",
    internalNote: "",
    status: "Pending confirmation",
    createdAt: new Date().toISOString()
  }
];
